import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import UploadPhoto from "../../../Global/UploadPhoto";
import useBulkUpload from "./useBulkUpload";

const BulkUpload = ({ refetch, handleClose }) => {
  const {
    formik,
    getFieldError,
    handleAssetsImagesChange,
    handleAssetsImagesDelete,
  } = useBulkUpload({ refetch, handleClose });

  return (
    <div className="input-wrap pro-mb-4">
      <div className="pro-mb-4 pro-w-100">
        <UploadPhoto
          previews={formik.values.assetsImages}
          handleChange={handleAssetsImagesChange}
          title={""}
          handleDeleteClick={handleAssetsImagesDelete}
          mutiple
          accept={".png,.jpeg,.jpg"}
          addText={"Add Images"}
          isError={!!getFieldError("assetsImages")}
          errorMsg={getFieldError("assetsImages")}
        />
      </div>

      <div className="input-wrap">
        <Input
          label={"Remarks"}
          type="text"
          id="remark"
          name="remark"
          className={`pro-input lg ${getFieldError("remark") && " error"}`}
          {...formik.getFieldProps("remark")}
          error={getFieldError("remark")}
          errorMessage={getFieldError("remark")}
        />
      </div>

      <div
        className={`col-12 pro-d-flex pro-justify-end pro-mt-5 offcanvas-footer-sticky-btn`}
      >
        <Button className={"pro-btn-link lg pro-px-5"} onClick={handleClose}>
          Cancel
        </Button>
        <Button
          className={`pro-btn-primary lg pro-ms-3 ${
            formik?.isSubmitting ? "loading" : ""
          }`}
          type="submit"
          disabled={formik?.isSubmitting}
          onClick={formik.handleSubmit}
        >
          {"Submit"}
        </Button>
      </div>
    </div>
  );
};

export default BulkUpload;
